import { render, staticRenderFns } from "./deviceArchives.vue?vue&type=template&id=93436520&scoped=true&"
import script from "./deviceArchives.vue?vue&type=script&lang=js&"
export * from "./deviceArchives.vue?vue&type=script&lang=js&"
import style0 from "./deviceArchives.vue?vue&type=style&index=0&id=93436520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93436520",
  null
  
)

export default component.exports